// extracted by mini-css-extract-plugin
module.exports = {"customer":"Customer_customer__Fbp7U","letter":"Customer_letter__4ugdK","contact":"Customer_contact__3Be2m","numbers":"Customer_numbers__10L96","email":"Customer_email__2e1_T"};